// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3978":"adbd1905","8866":"adbd1905"}[chunkId] + ".chunk.css";
};